// Constants
import { NOTIFICATION_PREFERENCE_BITS } from '../../../common/users/userConstants';

export const ACCOUNT_SETTINGS_COMMUNICATION_PREFERENCES = {
    PRODUCT_UPDATES: {
        value: NOTIFICATION_PREFERENCE_BITS.PRODUCT_UPDATES,
        label: 'Feature announcements, tips & product news',
    },
    ACTIVITY_DIGEST: {
        value: NOTIFICATION_PREFERENCE_BITS.ACTIVITY_DIGEST,
        label: 'A daily summary of changes in boards you share',
    },
    SHARED_BOARDS: {
        value: NOTIFICATION_PREFERENCE_BITS.SHARED_BOARDS,
        label: 'Invites you to a new board',
    },
    MENTIONS: {
        value: NOTIFICATION_PREFERENCE_BITS.MENTIONS,
        label: 'Mentions you by name',
    },
    COMMENTS: {
        value: NOTIFICATION_PREFERENCE_BITS.COMMENTS,
        label: 'Adds a comment to a board you share',
    },
    ASSIGNMENTS: {
        value: NOTIFICATION_PREFERENCE_BITS.ASSIGNMENTS,
        label: 'Assigns a task to you',
    },
    REMINDERS: {
        value: NOTIFICATION_PREFERENCE_BITS.REMINDERS,
        label: 'Reminders for tasks',
    },
};

export const EMAIL_PREFERENCE_UNSUBSCRIBE_DESCRIPTIONS = [
    {
        value: NOTIFICATION_PREFERENCE_BITS.ACTIVITY_DIGEST,
        label: 'daily summaries of changes to boards you share',
    },
    {
        value: NOTIFICATION_PREFERENCE_BITS.SHARED_BOARDS,
        label: 'alerts when someone shares a board with you',
    },
    {
        value: NOTIFICATION_PREFERENCE_BITS.MENTIONS,
        label: 'alerts when someone mentions you in a board',
    },
    {
        value: NOTIFICATION_PREFERENCE_BITS.ASSIGNMENTS,
        label: 'alerts when someone assigns a task to you',
    },
    {
        value: NOTIFICATION_PREFERENCE_BITS.REMINDERS,
        label: 'reminders for tasks',
    },
    {
        value: NOTIFICATION_PREFERENCE_BITS.PRODUCT_UPDATES,
        label: 'feature announcements, tips and product news',
    },
];
